<template>
    <div
        :class="[parentClass, 'form-input-checkbox']"
    >
        <div class="form-group d-flex align-items-center">
            <input
                v-model="inputValue"
                :value="inputValue ? 1 : 0"
                v-bind="$attrs"
                @input="handleInput"
                :id="uniqueId"
                :placeholder="placeholder || label"
                type="checkbox"
            >

            <label
                v-if="label"
                v-text="label"
                :for="uniqueId"
                class="ml-2 text-smaller"
            />
        </div>

        <slot />
    </div>
</template>

<script>
    export default {
        name: 'UiInputCheckbox',
        inheritAttrs: false,
        props: {
            checked: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: null,
            },
            parentClass: {
                type: String,
                default: '',
            },
            placeholder: {
                type: String,
                default: null,
            },
            value: {
                type: [String, Number, Boolean],
                default: '',
            },
        },
        data() {
            return {
                inputValue: this.value,
            };
        },
        mounted() {
            if (this.checked) {
                this.inputValue = true;
            }
        },
        computed: {
            uniqueId() {
                return this._uid;
            },
        },
        methods: {
            handleInput() {
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value(newVal) {
                this.inputValue = newVal;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form-input-checkbox:not(:last-child) {
        margin-bottom: 8px;
    }
</style>
